"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _ScrollCaptureService_filter;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollCaptureService = void 0;
const Logger_1 = __importDefault(require("./Logger"));
const Scroll_1 = require("./sensor/Scroll");
class ScrollCaptureService {
    constructor(contextService, elementCaptureService) {
        this.contextService = contextService;
        this.elementCaptureService = elementCaptureService;
        _ScrollCaptureService_filter.set(this, new Set(["*"]));
        this.debounce = {};
    }
    get featureEnabled() {
        return this.contextService.context.config.captureDocumentScrollEvents;
    }
    updatePosition({ id, scrollDepth, target, timestamp, }) {
        const scroll = {
            id,
            depth: scrollDepth,
            timestamp,
        };
        const state = this.debounce[id] || {
            component: this.elementCaptureService.collectFacets(target),
            displacement: {
                from: Object.assign(Object.assign({}, scroll), { depth: { x: 0, y: 0 } }),
                to: scroll,
            },
        };
        this.debounce[id] = state;
        state.displacement.to = scroll;
        if (!this.featureEnabled) {
            state.displacement.from = scroll;
        }
        return state;
    }
    resetPosition(id) {
        const state = this.debounce[id];
        this.debounce[id] = {
            component: state.component,
            displacement: {
                from: state.displacement.to,
                to: state.displacement.to,
            },
        };
        return state;
    }
    connect() {
        const onSensedScroll = ({ senseId, scrollDepth, target, timestamp }) => {
            const captured = this.elementCaptureService.getTarget(target, Array.from(__classPrivateFieldGet(this, _ScrollCaptureService_filter, "f")));
            if (!captured) {
                return;
            }
            const state = this.updatePosition({ id: senseId, scrollDepth, target, timestamp });
            if (!this.featureEnabled) {
                return;
            }
            const { timer } = state;
            if (timer) {
                // Reset the debounce timer
                clearTimeout(timer);
            }
            else {
                // Replace the start time
                state.displacement.from.timestamp = timestamp;
            }
            state.timer = setTimeout(() => {
                Logger_1.default.debug("Scroll timer elapsed");
                this.contextService.tracker.trackInternal({
                    autoCaptureContext: {
                        capturedElement: captured.target,
                        selector: captured.selector,
                        targetElement: target,
                    },
                    eventType: "GESTURE_COMPONENT",
                    trackInfo: Object.assign(Object.assign({}, state.component), { metrics: Object.assign(Object.assign({}, state.component.metrics), { SDK_CAPTURE: "auto", scrollXStartDepth: state.displacement.from.depth.x.toFixed(0), scrollYStartDepth: state.displacement.from.depth.y.toFixed(0), scrollXEndDepth: state.displacement.to.depth.x.toFixed(0), scrollYEndDepth: state.displacement.to.depth.y.toFixed(0), scrollDuration: (state.displacement.to.timestamp - state.displacement.from.timestamp).toFixed(0) }) }),
                });
                this.resetPosition(senseId);
            }, this.contextService.context.config.documentScrollSessionDuration);
        };
        (0, Scroll_1.senseScroll)(onSensedScroll.bind(this));
    }
    select(...elements) {
        __classPrivateFieldSet(this, _ScrollCaptureService_filter, new Set(elements), "f");
    }
}
exports.ScrollCaptureService = ScrollCaptureService;
_ScrollCaptureService_filter = new WeakMap();
